/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
import _ from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import CreateEmpGroupComponent from './createEmpGroup.Component';
import { MessageBox } from '../../sharedComponent/messageBox';
import { Constants } from '../../../config/appConstants';
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import { bindActionCreators } from 'redux';
import * as onHistorySaveAction from '../../../actions/history.Action';

/* Const,Let & Var will be here */

class CreateEmpGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allEmployeeList: [],
            employeeList : [],
            selectedEmployeeList: [],
            savedGroupName: '',
            grpName: '',
            grpList: [],
            groupId: this.props.location && this.props.location.state && this.props.location.state.groupId ? this.props.location.state.groupId : 0,
            alreadySelectedEmployees: [],
            searchText: "",
            isShowSaveConfirmation: false,
            isShowLoader: false,
            selectedDate: this.props.location && this.props.location.state && this.props.location.state.selectedDate ? this.props.location.state.selectedDate : new Date(),
            isDeleteConfirmationPopupVisible: false,
            selectedEmployeeListFromEmployee: this.props.location && this.props.location.state && this.props.location.state.selectedEmployeeList ? this.props.location.state.selectedEmployeeList : []
        };
    };
    componentDidMount() {
        this.props.onHistorySave(window.location.pathname);
        let { groupId } = this.state;
        this.getEmployeeList();
        if (groupId > 0) {
            this.getSelectedEmpGroup();
        }
    }

    componentWillUnmount(){
        if(this.props.history.action === "POP"){
            this.props.history.push('/AddTimeCard', {selectedEmployeeList: this.state.selectedEmployeeListFromEmployee})
        }
    }

    getEmployeeList() {
        let { searchText } = this.state;
        let requestData = (searchText) ? {
            SearchText: [
                { fieldName: "employeeName", value: searchText },
                { fieldName: "createTeam", value: "createTeam" }
            ]
        } : {
            SearchText: [{ fieldName: "createTeam", value: "createTeam" }]
        };
        let url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_AAEP_M}?deviceId=${this.props.device.deviceId}`;
        Api.Post(url, requestData, this, false).then((responseData) => {
            try {
                if (!searchText && responseData.success && responseData.data) {
                    this.setState({ allEmployeeList: responseData.data ,employeeList: responseData.data  });
                }
                else if (responseData.success && responseData.data) {
                    this.setState({ allEmployeeList: responseData.data });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    getSelectedEmpGroup() {
        let { selectedEmployeeList, grpName } = this.state;
        selectedEmployeeList=[];
        let url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.GT_EMP_GRP_BY_GRP_ID_M}?deviceId=${this.props.device.deviceId}&&groupId=${this.state.groupId}`;
        Api.Get(url, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {
                    let selectedEmp = responseData.data.data;
                    selectedEmp.sort((a, b) => (a.employeeName > b.employeeName) ? 1 : -1);
                    grpName = selectedEmp[0].groupName;
                    selectedEmp=selectedEmp.filter(g=> g.employeeID != null);
                    selectedEmp && selectedEmp.map((t) => {
                        selectedEmployeeList.push(Number(t.employeeID));  
                     });
                    this.setState({ selectedEmployeeList, grpName, savedGroupName: grpName, alreadySelectedEmployees: selectedEmp });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    onClickSave() {
        let { grpName, selectedEmployeeList, groupId, alreadySelectedEmployees } = this.state;
        if (grpName.trim() === '') {
            MessageBox(Constants.ENTER_FAVORITES_GROUP_NAME, Constants.ERROR);
            this.setState({
                isShowSaveConfirmation: false
            });
            return;
        }
        if (selectedEmployeeList.length === 0) {
            MessageBox(Constants.SELECT_ONE_OR_MORE_TO_GROUP.replace("{0}", "employee"), Constants.ERROR);
            this.setState({
                isShowSaveConfirmation: false
            });
            return;
        }
        var empIds = [];
        if (groupId === 0) {
            selectedEmployeeList.map((id) => {
                empIds.push({
                    EmpId: id,
                    IsActive: true
                })
            });
        }
        else {
            selectedEmployeeList.map((id) => {
                empIds.push({
                    EmpId: id,
                    IsActive: true
                })
            });

            // Adding existing employees which are all unselected
            alreadySelectedEmployees && alreadySelectedEmployees.filter(e =>
                !selectedEmployeeList.includes(Number(e.employeeID))).map((t) => {
                    empIds.push({
                        EmpId: Number(t.employeeID),
                        IsActive: false
                    })
                });
        }
        let requestData = {
            GroupId: groupId,
            DeviceID: this.props.device.deviceId,
            GroupName: grpName,
            EmpIds: empIds
        }
        let url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.SV_EMP_GRP_M}`;
        Api.Post(url, requestData, this).then((response) => {
            if (response.success) {
                MessageBox(response.message, Constants.SUCCESS);
                this.setState({
                    isShowSaveConfirmation: false
                });
                this.props.history.push("/AddTimeCard", { selectedDate: this.state.selectedDate, selectedEmployeeList: this.state.selectedEmployeeListFromEmployee });
            }
            else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    onSearch(event) {
        this.setState({ searchText: event.target.value },
            () => {
                this.getEmployeeList();
            });
    }

    onEmployeeSelect(e, data) {
        let { selectedEmployeeList } = this.state;
        if (selectedEmployeeList.indexOf(data.value) < 0) {
            selectedEmployeeList.push(data.value);
        }
        else {
            var index = selectedEmployeeList.indexOf(data.value);
            selectedEmployeeList.splice(index, 1);
        }

        this.setState({ selectedEmployeeList });
    }

    handleChangeGrpName = (event) => {
        this.setState({
            grpName: event.target.value
        });
    }

    onClickDelete() {
        this.setState({
            isDeleteConfirmationPopupVisible: true
        });
    }

    onDeleteClickInConfirmationPopup() {
        let { groupId } = this.state;
        let url = `${ApiUrls.Routes.EMPLE_C}${ApiUrls.Routes.DL_EMP_GRP_M}?groupId=${groupId}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                MessageBox(responseData.data.message, Constants.SUCCESS);
                this.props.history.push("/AddTimeCard", { selectedEmployeeList: this.state.selectedEmployeeListFromEmployee });
            }else{
                MessageBox(responseData.message,Constants.ERROR);
            }
        });
    }

    onCancelClickInConfirmationPopup() {
        this.setState({
            isDeleteConfirmationPopupVisible: false
        });
    }

    onClickBack() {
        const { grpName, savedGroupName, selectedEmployeeList, alreadySelectedEmployees } = this.state;
        let sortSelectedEmployee = selectedEmployeeList.slice().sort((a, b) => a - b);
        let sortSavedSelectedEmployee = alreadySelectedEmployees?.map(a=> +a.employeeID).slice().sort((a, b) => a - b);
        if (!_.isEqual(grpName, savedGroupName) || !_.isEqual(sortSelectedEmployee, sortSavedSelectedEmployee)) {
            this.setState({
                isShowSaveConfirmation: true
            });
        }
        else {
            this.goBack();
        }
    }

    onCloseModel() {
        this.setState({
            isShowSaveConfirmation: false
        });
        this.goBack();
    }

    goBack() {
        this.props.history.push("/AddTimeCard", { selectedEmployeeList: this.state.selectedEmployeeListFromEmployee });
    }

    render() {
        const { allEmployeeList,employeeList, selectedEmployeeList, grpName, groupId, alreadySelectedEmployees, searchText, isShowSaveConfirmation, isShowLoader, isDeleteConfirmationPopupVisible } = this.state;
        return (
            <Fragment>
                <CreateEmpGroupComponent
                    {...{
                        createEmpGroup: {
                            allEmployeeList,
                            employeeList,
                            selectedEmployeeList,
                            grpName,
                            groupId,
                            alreadySelectedEmployees,
                            searchText,
                            isShowSaveConfirmation,
                            isShowLoader,
                            isDeleteConfirmationPopupVisible
                        }
                    }}
                    onClickSave={this.onClickSave.bind(this)}
                    onSearch={this.onSearch.bind(this)}
                    onEmployeeSelect={this.onEmployeeSelect.bind(this)}
                    handleChangeGrpName={this.handleChangeGrpName.bind(this)}
                    onClickDelete={this.onClickDelete.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onDeleteClickInConfirmationPopup={this.onDeleteClickInConfirmationPopup.bind(this)}
                    onCancelClickInConfirmationPopup={this.onCancelClickInConfirmationPopup.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            onHistorySaveAction),
        dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CreateEmpGroup));

CreateEmpGroup.displayName = 'CreateEmpGroup';